export default "__VITE_ASSET__Bc62XTw1__"